import Cookies from 'js-cookie';

import { Analytics } from '@trello/atlassian-analytics';
import { client } from '@trello/graphql';
import { memberId } from '@trello/session-cookie';
import { TrelloStorage } from '@trello/storage';
import { TrelloWindow } from '@trello/window-types';

import {
  MemberLocalePrefDocument,
  MemberLocalePrefQuery,
  MemberLocalePrefQueryVariables,
} from './MemberLocalePrefQuery.generated';

declare const window: TrelloWindow;

export async function sendAppBootstrappedEvent(
  timeSinceOriginInMilliseconds: number,
) {
  const additionalAttributes: {
    cachedLocaleMemberPref?: string;
    localeMemberPref?: string;
  } = {};

  if (memberId) {
    const STORAGE_KEY = `locale-${memberId}`;

    additionalAttributes.cachedLocaleMemberPref = TrelloStorage.get(
      STORAGE_KEY,
    );

    const { data } = await client.query<
      MemberLocalePrefQuery,
      MemberLocalePrefQueryVariables
    >({
      query: MemberLocalePrefDocument,
      variables: { memberId },
      context: {
        operationName: 'MemberLocalePref',
        document: MemberLocalePrefDocument,
      },
    });

    const localeMemberPref = data?.member?.prefs?.locale;

    if (localeMemberPref) {
      additionalAttributes.localeMemberPref = localeMemberPref;
      TrelloStorage.set(STORAGE_KEY, localeMemberPref);
    }
  }

  Analytics.sendOperationalEvent({
    source: 'appStartup',
    action: 'bootstrapped',
    actionSubject: 'app',
    attributes: {
      timeSinceOriginInMilliseconds,
      loadedLocale: window.locale,
      langOverrideCookie: Cookies.get('langOverride'),
      navigatorLanguages: navigator.languages,
      ...additionalAttributes,
    },
  });
}
